<template>
  <div id="app" :style="cssVars">
    <transition name="fade-fast" mode="out-in">
      <keep-alive>
        <router-view
          :isUserProspect="isUserProspect"
          @postEstimate="postEstimate"
        />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { SCHEMA_VERSION } from "./constants/schemaVersion";
import getLocale from "./helpers/getLocale";
import { defaultVars, nordrumVars } from "./helpers/cssVars";
import postProspcalculator from "./helpers/api/postProspcalculator";

export default {
  name: "App",
  data: function() {
    return {
      static_sessionId: {
        sessionId: null
      },
      static_marketCode: {
        marketCode: null
      },
      static_intitialQuery: {
        initialQuery: null
      },
      // A counter to indicate iterations for api POST
      // calls to backend within the current user session
      generation: 0
    };
  },
  computed: {
    isUserProspect: function () {
      const initialQuery = this.static_intitialQuery.initialQuery;

      return initialQuery && initialQuery.cnoh ? true : false
    },
    cssVars: function() {
      const marketCode = this.static_marketCode.marketCode;
      return marketCode === "FI-NR" ? nordrumVars : defaultVars;
    }
  },
  created: function() {
    this.static_sessionId.sessionId = uuidv4();
    this.static_intitialQuery.initialQuery = this.$route.query;

    const locale = getLocale();

    if (locale === "sv") {
      this.static_marketCode.marketCode = "SE-SKBV";
    } else if (locale === "no") {
      this.static_marketCode.marketCode = "NO-GF";
    } else if (locale === "fi") {
      this.static_marketCode.marketCode = "FI-NR";
    }

    Object.freeze(this.static_sessionId);
    Object.freeze(this.static_marketCode);
    Object.freeze(this.static_initialQuery);
  },
  methods: {
    postEstimate(data, callbacks) {
      this.generation += 1;

      postProspcalculator(
        {
          schemaVersion: SCHEMA_VERSION,
          sessionId: this.static_sessionId.sessionId,
          marketCode: this.static_marketCode.marketCode,
          generation: this.generation,
          urlParams: this.static_intitialQuery.initialQuery,
          ...data
        },
        callbacks
      );
    }
  }
};
</script>

<style lang="scss">
body {
  margin: 0;
}

#app {
  font-family: var(--font-brand);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--primary-black);
  max-width: 100em;
  margin: 0 auto;
}

.fade-fast-enter-active,
.fade-fast-leave-active {
  transition: opacity 0.3s;
}
.fade-fast-enter,
.fade-fast-leave-to {
  opacity: 0;
}

@media (max-width: $medium) {
  #app {
    margin-top: -20px;
  }
}
</style>
